/* global axios */
import ApiClient from './ApiClient';

class SearchAPI extends ApiClient {
  constructor() {
    super('search', { accountScoped: true });
    this.controllers = new Map();
  }

  request(key, url, params) {
    this.controllers.get(key)?.abort();
    const controller = new AbortController();
    this.controllers.set(key, controller);

    return axios
      .get(url, {
        params,
        signal: controller.signal,
      })
      .finally(() => {
        if (this.controllers.get(key) === controller) {
          this.controllers.delete(key);
        }
      });
  }

  cancelAll() {
    this.controllers.forEach(controller => controller.abort());
    this.controllers.clear();
  }

  get({ q, field }) {
    return this.request('all', this.url, { q, field });
  }

  contacts({ q, page = 1, field }) {
    return this.request('contacts', `${this.url}/contacts`, { q, page, field });
  }

  conversations({ q, page = 1, field }) {
    return this.request('conversations', `${this.url}/conversations`, {
      q,
      page,
      field,
    });
  }

  messages({ q, page = 1, field }) {
    return this.request('messages', `${this.url}/messages`, { q, page, field });
  }

  articles({ q, page = 1, field }) {
    return this.request('articles', `${this.url}/articles`, { q, page, field });
  }
}

export default new SearchAPI();
